// extracted by mini-css-extract-plugin
export default {"controls":"ygtsJxIfm9hFbNz_OlUA","placeHolderShimmer":"EEcWW2UjdABng99lLBGl"};